import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Ambulance, Car, Home, LogOut, History } from "lucide-react";
import { clearPassengerSession, getPassengerData } from "../../passengerAuth";
import "./Passenger.css";

export default function PassengerLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const passenger = getPassengerData();

  const firstName = passenger?.firstName || "";
  const lastName = passenger?.lastName || "";
  const fullName = `${firstName} ${lastName}`.trim() || "Passenger";
  const phone = passenger?.phoneNumber || "";

  const initials = `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase() || "P";

  const navLinks = [
    { path: "/passenger", label: "Services", icon: <Ambulance size={16} />, exact: true },
    { path: "/passenger/ride", label: "Non-Emergency", icon: <Car size={16} /> },
    { path: "/passenger/emergency", label: "Emergency", icon: <Ambulance size={16} /> },
    // { path: "/passenger/homecare", label: "Home Care", icon: <Home size={16} /> }, // temporarily disabled
    { path: "/passenger/trips", label: "My Trips", icon: <History size={16} /> },
  ];

  const isActive = (link) =>
    link.exact
      ? location.pathname === link.path
      : location.pathname === link.path;

  return (
    <div className="pax-shell">
      <nav className="pax-navbar">
        <div className="pax-navbar-inner">
          {/* BRAND */}
          <div className="pax-nav-brand" onClick={() => navigate("/passenger")}>
            <div className="pax-nav-logo">
              <Ambulance size={20} />
            </div>
            <div>
              <div className="pax-nav-title">ለAmbulance</div>
              <div className="pax-nav-subtitle">Passenger Portal</div>
            </div>
          </div>

          {/* NAV LINKS */}
          <div className="pax-nav-links">
            {navLinks.map((link) => (
              <button
                key={link.path}
                className={`pax-nav-link${isActive(link) ? " active" : ""}`}
                onClick={() => navigate(link.path)}
              >
                {link.icon}
                {link.label}
              </button>
            ))}
          </div>

          {/* RIGHT USER */}
          <div className="pax-nav-right">
            <div className="pax-user-chip">
              <div className="pax-user-avatar">{initials}</div>
              <div>
                <div className="pax-user-name">{fullName}</div>
                <div className="pax-user-phone">{phone}</div>
              </div>
            </div>
            <button
              className="pax-logout-btn"
              id="pax-logout-btn"
              onClick={() => {
                clearPassengerSession();
                navigate("/passenger/login");
              }}
            >
              <LogOut size={15} />
              Logout
            </button>
          </div>
        </div>
      </nav>

      <main className="pax-content">
        <Outlet />
      </main>
    </div>
  );
}
